import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';


@Injectable({ providedIn: 'root' })
export class EntradaCedoService {

     constructor(private http: HttpClient) {
    
    }

    registrar(cedos_entrada) {
      console.log("entramos en registrar")

      return this.http.post<any>('https://vertigofin.herokuapp.com/cedos_entradas', { cedos_entrada})
        .pipe(map(confirmacion => {
       
            console.log("entramos en respuesta de registrar entrada")
            console.log(confirmacion)
            return confirmacion;
        }));
    }


}